<script setup lang="ts">
import { ref } from 'vue'

const isHidden = ref(false)
</script>

<template>
  <div v-if="!isHidden" class="vpn-warning-banner">
    <div class="container">
      <div class="banner-content">
        <div class="banner-left">
          <span class="banner-text">Для стабильной работы сервиса отключите VPN</span>
        </div>
        <button class="hide-button" @click="isHidden = true" type="button" aria-label="Скрыть баннер">
          скрыть
        </button>
      </div>
    </div>
  </div>
</template>

<style lang="scss" scoped>
.vpn-warning-banner {
  color: #2f3462;
  background: #efefef9c;
  padding: 20px;
  position: fixed;
  bottom: 0;
  left: 0;
  right: 0;
  z-index: 1000;
  box-shadow: 0 -2px 10px rgba(0, 0, 0, 0.1);

  .banner-content {
    display: flex;
    justify-content: space-between;
    align-items: center;
  }

  .banner-background {
    position: absolute;
    left: 0;
    top: 0;
    width: 100%;
    height: 100%;
    background-color: #f3f3f3;
    opacity: 0.9;
  }

  .banner-left {
    display: flex;
    align-items: center;
    gap: 12px;
  }

  .vpn-icon {
    width: 48px;
    height: 48px;
    flex-shrink: 0;
  }

  .banner-text {
    font-size: 20px;
    font-weight: 500;
  }

  .hide-button {
    background: none;
    border: none;
    color: #97aab5;
    cursor: pointer;
    font-size: 14px;
    text-decoration: underline;
    padding: 0;
    margin-left: 16px;

    &:focus {
      outline: 2px solid #97aab5;
      outline-offset: 2px;
    }
  }
}

@media (max-width: 768px) {
  .vpn-warning-banner {
    .banner-left {
      justify-content: center;
    }

    .hide-button {
      margin-left: 0;
    }

    .banner-text {
      font-size: 14px;
      font-weight: 500;
    }
  }
}
</style>
